"use client";

import React, { useEffect, useState } from 'react';

const Typewriter = ({ texts, speed = 80, delay = 2000, maxWidth = '10ch' }) => {
  const [displayedText, setDisplayedText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [showCursor, setShowCursor] = useState(true);

  useEffect(() => {
    const handleTyping = () => {
      const currentText = texts[currentIndex];
      let updatedText = isDeleting
        ? currentText.substring(0, displayedText.length - 1)
        : currentText.substring(0, displayedText.length + 1);

      setDisplayedText(updatedText);

      if (!isDeleting && updatedText === currentText) {
        setTimeout(() => setIsDeleting(true), delay);
      } else if (isDeleting && updatedText === '') {
        setIsDeleting(false);
        setCurrentIndex((prev) => (prev + 1) % texts.length);
      }
    };

    const typingSpeed = isDeleting ? speed / 2 : speed;
    const typingTimeout = setTimeout(handleTyping, typingSpeed);

    return () => clearTimeout(typingTimeout);
  }, [displayedText, isDeleting, currentIndex, texts, speed, delay]);

  useEffect(() => {
    const cursorInterval = setInterval(() => {
      setShowCursor((prev) => !prev);
    }, 500); // Blink cursor every 500ms

    return () => clearInterval(cursorInterval);
  }, []);

  return (
    <span style={{ whiteSpace: 'nowrap', display: 'inline-block', textAlign: 'center', maxWidth }}>
      {displayedText}
      <span className="cursor" style={{ opacity: showCursor ? 1 : 0 }}>|</span>
    </span>
  );
};

export default Typewriter;
